import { getSearchParams } from './LocationService';

export default {
  async getIssueKey(): Promise<string> {
    let AJS: typeof window.AJS;
    if (window.frameElement !== null && window.frameElement !== undefined) {
      AJS = window.parent.AJS;
    } else {
      AJS = window.AJS;
    }
    let issueKey = getSearchParams().get('selectedIssue');
    while (!issueKey) {
      await sleep(1000);
      issueKey = AJS.Meta.get('issue-key');
    }

    return issueKey;
  },

  async getReportName(): Promise<string> {
    return getSearchParams().get('reportName');
  },

  async getProjectIdOrKey(): Promise<string> {
    return getSearchParams().get('selectedProjectId');
  },

  async getProjectId(): Promise<string> {
    return getSearchParams().get('selectedProjectId');
  },
};

function sleep(ms) {
  // eslint-disable-next-line promise/avoid-new
  return new Promise((resolve) => setTimeout(resolve, ms));
}
